import { render, staticRenderFns } from "./LinkDyTrend.vue?vue&type=template&id=56e5c7a4&"
import script from "./LinkDyTrend.vue?vue&type=script&lang=js&"
export * from "./LinkDyTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports